// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const tandemaus: PokeData = {
  "id": 924,
  "name": "tandemaus",
  "height": 3,
  "weight": 18,
  "base_experience": 61,
  "types": [
    PokeType.NORMAL
  ],
  "api_moves": [
    "pound",
    "super-fang",
    "charm",
    "encore",
    "beat-up",
    "helping-hand",
    "hyper-voice",
    "bullet-seed",
    "copycat",
    "double-hit",
    "echoed-voice",
    "play-rough",
    "baby-doll-eyes",
    "population-bomb"
  ],
  "moves": [
    "hyper-voice",
    "bullet-seed",
    "play-rough",
    "splash",
    "body-slam",
    "purification",
    "headbutt",
    "tri-attack",
    "leer",
    "refresh",
    "scratch",
    "protect",
    "growl"
  ],
  "evolution_chain": {
    "id": 485,
    "item": null,
    "species": [
      {
        "name": "tandemaus",
        "order": 945,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "maushold",
        "order": 946,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": 924,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 25,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.OTHER
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 47.5,
    "speed": 75,
    "ability_power": 50
  },
  "stat_changes": [],
  "catch_rate": 150,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
